import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import { useMenuManagementMenuCache } from 'hooks/useMenuManagementMenuCache';
import { MenuManagementMenuPreviewProvider } from 'context/MenuManagementMenuPreviewProvider';

import { Button, Card, Loader, Text, Title } from '@mantine/core';
import { Menu } from 'components/MenuManagement/MenuPreview';
import MenuInformation from 'components/MenuManagement/MenuInformation';
import { ArrowLeftIconMd } from '@chownow/pantry/icons';

function MenuPreview() {
  const {
    previewMenu: { menuUuid, merchantID, companyID },
  } = useContext(MenuInformation.Context);

  const { isLoading, isReady, triggerCache } = useMenuManagementMenuCache({
    menuID: menuUuid,
    merchantID,
    companyID,
  });

  useEffect(() => {
    if (!isReady) return;
    // eslint-disable-next-line no-return-await
    (async () => await triggerCache())();
  }, [isReady, triggerCache]);

  let content;

  if (isLoading) {
    content = (
      <Card py="xl2" align="center">
        <Loader mx="auto" mb="lg" />
        <Title order={6} data-cy="preview-menu-loading">
          Building your menu
        </Title>
        <Text mt="sm">
          If changes have been made to the menu since the last preview, generating a new preview may
          take up to 2 minutes
        </Text>
      </Card>
    );
  } else {
    content = (
      <div className="pl-10 pr-10">
        <MenuManagementMenuPreviewProvider>
          <Menu />
        </MenuManagementMenuPreviewProvider>
      </div>
    );
  }

  return content;
}

function BackButton({ handleBack }) {
  return (
    <Button
      leftSection={<ArrowLeftIconMd />}
      mb="md"
      onClick={handleBack}
      td="none"
      variant="link-uppercase"
      display={{ base: 'none', lg: 'flex' }}
    >
      Back
    </Button>
  );
}

BackButton.propTypes = {
  handleBack: PropTypes.func.isRequired,
};

export default MenuPreview;
